/* eslint-disable eqeqeq */
/* eslint-disable react-hooks/exhaustive-deps */
/*
 * Author M. Atoar Rahman
 * Title: Pending Stock Return Request Table
 * Description: Pending Stock Return Request Table
 * Date: 05/06/2022
 */

import moment from 'moment';
import { useCallback, useEffect } from 'react';
import { Badge, Button } from 'react-bootstrap';
import useAxiosPrivate from '../../../hooks/useAxiosPrivate';
import useDataTable from '../../../hooks/useDataTable';
import UrlService from '../../../services/UrlService';
import { useStockReturn } from './ContextAPI';

export default function ApprovedTable() {
    const { setShowModal, setRowData, approvedData, getApprovedData } = useStockReturn();
    const axiosPrivate = useAxiosPrivate();

    const handleShow = async (row) => {
        try {
            const response = await axiosPrivate.get(
                UrlService.getAllFacilityStockReturnItemsUrl(row.id),
                {
                    headers: {
                        'Content-Type': 'application/json',
                    },
                }
            );

            const row_info = {
                master_id: row.id,
                partner_name: row.partner_name,
                facility_name: row.facility_name,
                requested_by_date: row.requested_by_date,
                status: row.status,
                records: response?.data?.request_info,
            };
            setRowData(row_info);
            setShowModal(true);
        } catch (err) {
            if (!err?.response) {
                console.log('Server Not Responding!');
            } else if (err.response?.status === 401) {
                console.log('Unauthorized!');
            } else {
                console.log('Data Not Found!');
            }
        }
    };

    const dataList = useCallback(() => {
        getApprovedData();
    }, []);

    useEffect(() => {
        dataList();
    }, [dataList]);

    const columns = [
        {
            name: 'Partner Name',
            selector: (row) => row.partner_name,
            sortable: true,
            wrap: true,
        },
        {
            name: 'Facility Name',
            selector: (row) => row.facility_name,
            sortable: true,
            wrap: true,
        },
        {
            name: 'Requested Date',
            selector: (row) =>
                row.requested_by_date ? moment(row.requested_by_date).format('DD MMM YYYY') : '',
            sortable: true,
        },
        {
            name: 'Status',
            selector: (row) => row.status,
            center: true,
            cell: (row) =>
                row.status == 'received' ? (
                    <Badge className="badgeActive" bg="success">
                        Received
                    </Badge>
                ) : row.status == 'received_apv' ? (
                    <Badge className="badgeActive" bg="success">
                        Received Apv
                    </Badge>
                ) : (
                    <Badge className="badgeInactive" bg="success">
                        Pending
                    </Badge>
                ),
        },
        {
            name: 'Action',
            selector: (row) => row.action,
            center: true,
            cell: (row) => (
                <Button
                    className="btn btn-light btnSuccess"
                    variant="primary"
                    onClick={() => handleShow(row)}
                >
                    View
                </Button>
            ),
        },
    ];

    const search_column = {
        // facility_name: 'Facility',
        // submited_date: 'Submited Date',
    };
    return useDataTable({ columns, data: approvedData, search_column });
}
